<template>
  <div>
    <div
      v-if="selectedTypeGraph == 'bigram' || selectedTypeGraph == 'person'"
      style="display: flex; height: 100vh;"
    >
      <!-- Graph Container -->
      <div id="sigma-container" style="position: absolute; top: 46px; height: 100%;"></div>
      <div style="position: absolute; top: 46px; left: 26px;">
        <v-btn v-if="isStartStop == false" color="success" @click="startLayout(), postDescribeGraphNode()">
          Start
        </v-btn>
        <v-btn v-if="isStartStop == true" class="white--text" color="red" @click="stopLayout()">
          Stop
        </v-btn>
      </div>

      <div style="position: absolute; bottom: 140px; left: 26px;">
        <v-btn-toggle class="btn-vertical" style="background-color: #F5F5F5">
          <v-btn icon outlined color="primary" @click="exitFullScreen">
            <v-icon>mdi-fullscreen</v-icon>
          </v-btn>
          <v-btn icon outlined color="primary" @click="zoomIn">
            <v-icon>mdi-magnify-plus</v-icon>
          </v-btn>
          <v-btn icon outlined color="primary" @click="zoomOut">
            <v-icon>mdi-magnify-minus</v-icon>
          </v-btn>
          <v-btn icon outlined color="primary" @click="rotationLayout">
            <v-icon>mdi-rotate-left</v-icon>
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <!-- Hypergraph -->
    <div v-if="selectedTypeGraph == 'hypergraph'" style="display: flex; height: 100vh; position: relative;">
      <canvas id="canvasHypergraph"></canvas>

      <div
        :style="{
          position: 'absolute',
          bottom: openOpacity ? '40px' : '140px',
          left: '26px'
        }"
      >
        <v-btn-toggle class="btn-vertical" style="background-color: #F5F5F5; width: 50px">
          <div
            v-if="openOpacity == true"
            style="margin-top: 100px; margin-bottom: 10px; transform: rotate(-90deg); background-color: #F5F5F5;"
          >
            <input
              type="range"
              id="alphaSlider"
              min="0"
              max="1"
              step="0.01"
              value="0.1"
              style="width: 200px; vertical-align: middle; cursor: pointer"
              @input="updateHypergraphOpacity($event.target.value)"
            >
          </div>
          <v-btn style="margin-top: 100px;" color="primary" icon @click="openOpacity = !openOpacity">
            <svg-icon
              type="mdi"
              :path="pathIconOpacity"
              :style="{ color: '#000000' }"
            ></svg-icon>
          </v-btn>
          <v-btn icon color="primary" @click="exitFullScreen">
            <v-icon>mdi-fullscreen</v-icon>
          </v-btn>
          <v-btn icon color="primary" @click="zoomIn">
            <v-icon>mdi-magnify-plus</v-icon>
          </v-btn>
          <v-btn icon color="primary" @click="zoomOut">
            <v-icon>mdi-magnify-minus</v-icon>
          </v-btn>
          <v-btn icon color="primary" @click="rotationLayout">
            <v-icon>mdi-rotate-left</v-icon>
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>
      <!-- Cluster Dialog -->
      <div v-if="selectedTypeGraph == 'bigram' || selectedTypeGraph == 'person'" style="position: absolute; top: 38px; right: 0; width: 30%;">
        <!-- Cluster Dialog with v-menu -->
<v-menu v-model="dialogCluster">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" style="display: flex; justify-content: flex-end; width: 100%; cursor: pointer;">
        <span class="mt-1">Configuration</span>
        <v-icon class="mr-4" color="grey darken-2" style="margin-left: 4px;">
          mdi-chevron-down
        </v-icon>
      </div>
    </template>

  <v-card style="width: 400px; overflow-y: auto;" @click.stop>
    <v-expansion-panels @click.stop>
      <v-expansion-panel v-for="(item, i) in panels" :key="i">
        <v-expansion-panel-header>
          <h3>{{ item }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>

          <template v-if="i == 0">
            <p>Click a community to show/hide related pages from the network.</p>
            <v-btn width="330" medium outlined @click="dialogModularity = true; handleInputModularityScore()">
              <span class="ml-3 mr-4">Advanced Settings</span>
            </v-btn>

            <div v-if="clusters.length" class="d-flex justify-space-between mt-1 ml-4">
              <v-row class="d-flex justify-end" align="center" :style="isCheckAll ? 'margin-left: 65px' : 'margin-left: 25px'">
                <v-col cols="2">
                  <v-checkbox
                    v-model="isCheckAll"
                    color="#000"
                    @click="clickCheckAll"
                  ></v-checkbox>
                </v-col>
                <v-col cols="5">
                  <span v-if="isCheckAll">Check All</span>
                  <span v-else>Uncheck All</span>
                </v-col>
              </v-row>
            </div>

            <v-list dense>
              <v-list-item v-for="(cluster, index) in clusters" :key="index">
                <v-list-item-action>
                  <v-checkbox
                    v-model="cluster.checked"
                    color="#000"
                    @click="toggleCluster(cluster.name)"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <v-avatar :color="cluster.color" size="20"></v-avatar>
                    <v-list-item-title>{{ cluster.label }}</v-list-item-title>
                    <v-list-item-title style="margin-left: auto; text-align: right;">
                      {{ cluster.percentage }} %
                    </v-list-item-title>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>

          <template v-else-if="i == 1">
            <v-select
              :items="itemsLayout"
              v-model="selectedLayout"
              label="Select Layout"
              @change="applyLayout"
            ></v-select>
          </template>

          <template v-else-if="i == 2">
            <v-list dense>
              <v-list-item v-for="(itemAdv, index) in itemsAdvanced" :key="index">
                <v-row align="center">
                  <v-col cols="7">
                    <template v-if="index == 0">
                      <v-select
                        :items="itemsNodeSize"
                        item-text="name"
                        item-value="value"
                        v-model="selectedNodeSize"
                        label="Select Node Size"
                        :style="{ width: '150px' }"
                      ></v-select>
                    </template>

                    <template v-else-if="index == 1">
                      <SliderComponent v-model="sliderNodeSize" @update:modelValue="dataSlider" />
                      <div class="mt-8">Min: {{ sliderNodeSize[0] }} Max: {{ sliderNodeSize[1] }}</div>
                    </template>

                    <template v-else-if="index == 2">
                      <v-checkbox v-model="valueEdgesWeights" color="#000"></v-checkbox>
                    </template>

                    <template v-else-if="index == 3">
                      <SliderComponentEdges
                        v-model="sliderEdgesSize"
                        :valueEdgesWeights="valueEdgesWeights"
                        :sliderEdgesSize="sliderEdgesSize"
                        @update:modelValueEdges="dataSliderEdges"
                      />
                      <div class="mt-8">Min: {{ sliderEdgesSize[0] }} Max: {{ sliderEdgesSize[1] }}</div>
                    </template>

                    <template v-else-if="index == 4">
                      <v-row align="center">
                        <v-col cols="6">
                          <v-checkbox v-model="selectedEdgesStyle" color="#000" label="Straight" value="straight"></v-checkbox>
                        </v-col>
                        <v-col cols="6" class="pl-6">
                          <v-checkbox v-model="selectedEdgesStyle" color="#000" label="Curved" value="curved"></v-checkbox>
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>

                  <v-col cols="5">
                    <v-list-item-content>
                      <v-list-item-title>{{ itemAdv }}</v-list-item-title>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>

            <v-row justify="end">
              <v-btn class="mt-2 mb-5 white--text" color="#000" @click="applyInitializeGraph">
                Apply
              </v-btn>
            </v-row>
          </template>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</v-menu>
      </div>

      <div v-if="selectedTypeGraph == 'hypergraph'" style="position: absolute; top: 38px; right: 0; width: 30%;">
        <!-- Hypergraph Cluster Dialog with v-menu -->
        <v-menu v-model="dialogHypergraphCluster">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" style="display: flex; justify-content: flex-end; width: 100%; cursor: pointer;">
              <span class="mt-1">Configuration</span>
              <v-icon class="mr-4" color="grey darken-2" style="margin-left: 4px;">
                mdi-chevron-down
              </v-icon>
            </div>
          </template>

          <v-card style="width: 400px; overflow-y: auto;" @click.stop>
            <v-expansion-panels @click.stop>
              <v-expansion-panel v-for="(item, i) in panelsHypergraph" :key="i">
                <v-expansion-panel-header>
                  <h3>{{ item }}</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <template v-if="i == 0">
                    <p>Click a community to show/hide related pages from the network.</p>
                    <v-btn width="330" medium outlined @click="dialogModularity = true, handleInputModularityScore()">
                      <span class="ml-3 mr-4">
                        Advanced Settings
                      </span>
                    </v-btn>

                    <div v-if="clusters.length != 0" class="d-flex justify-space-between mt-1 ml-4">
                      <v-row align="center" class="d-flex justify-end" :style="isCheckAll ? 'margin-left: 65px' : 'margin-left: 25px'">
                        <v-col cols="2">
                          <v-checkbox
                            v-model="isCheckAll"
                            color="#000"
                            @click="clickCheckAll"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="5">
                          <span v-if="isCheckAll == true">
                            Check All
                          </span>
                          <span v-if="isCheckAll == false">
                            Uncheck All
                          </span>
                        </v-col>
                      </v-row>
                    </div>

                    <v-list dense>
                      <v-list-item v-for="(cluster, index) in clusters" :key="index">
                        <v-list-item-action>
                          <v-checkbox
                            v-model="cluster.checked"
                            color="#000"
                            @click="toggleCluster(cluster.name)"
                          ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <div style="display: flex; align-items: center; gap: 8px;">
                            <v-avatar :color="cluster.color" size="20"></v-avatar>
                            <v-list-item-title>
                              {{ cluster.label }}
                            </v-list-item-title>
                            <v-list-item-title style="margin-left: auto; text-align: right;">
                              {{ cluster.percentage }} %
                            </v-list-item-title>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </template>

                  <template v-if="i == 1">
                    <v-list dense>
                      <v-list-item v-for="(item, index) in itemsAdvanced" :key="index">
                        <v-row align="center">
                          <v-col cols="7">
                            <template v-if="index == 0">
                              <v-list-item-action class="mt-4">
                                <v-select
                                  :items="itemsNodeSizeHypergraph"
                                  item-text="name"
                                  item-value="value"
                                  v-model="selectedNodeSizeHypergraph"
                                  label="Select Node Size"
                                  :style="{ width: '150px' }"
                                ></v-select>
                              </v-list-item-action>
                            </template>

                            <template v-if="index == 1">
                              <SliderComponent v-model="sliderNodeSize" @update:modelValue="dataSlider" />
                              <div class="mt-8">
                                Min: {{ sliderNodeSize[0] }} Max: {{ sliderNodeSize[1] }}
                              </div>
                            </template>
                          </v-col>

                          <v-col cols="5">
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </v-list>

                    <v-row justify="end">
                      <v-btn
                        class="mt-2 mb-5 white--text"
                        color="#000"
                        @click="applyInitializeGraph"
                      >
                        Apply
                      </v-btn>
                    </v-row>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-menu>
      </div>

      <v-dialog v-model="dialogModularity" max-width="560">
        <v-card>
          <v-card-title>
            Modularity settings
          </v-card-title>
          <v-card-title>
            Modularity
          </v-card-title>
          <v-card-subtitle class="mt-2">
            Community detection algorithm.
          </v-card-subtitle>
          <v-card-text>
            <v-form>
              <v-row align="center">
                <v-col cols="4">
                  <v-checkbox
                    v-model="settingsModularity.randomize"
                    label="Randomize"
                  ></v-checkbox>
                </v-col>
                <v-col cols="8">
                  <span>Produce a better decomposition but increases computation time</span>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="4">
                  <b class="black--text">Resolution:</b>
                </v-col>
                <v-col cols="8">
                  <span>Lower to get more communities (smaller ones) and higher than 1.0 to get larger ones.</span>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="4" style="height: 80px">
                  <v-text-field
                    v-model="settingsModularity.resolution"
                    outlined
                    style="width: 150px;"
                    v-on:input="handleInputModularityScore()"
                  ></v-text-field>
                </v-col>
                <v-col cols="8">
                  Modularity score is <b class="black--text">{{ modularityScore }}</b>
                </v-col>
              </v-row>

              <br>

              <b class="black--text">Palette:</b>
              <v-row class="mt-1">
                <div
                  v-for="(row, rowIndex) in colorPaletteCluster"
                  :key="rowIndex"
                  class="d-flex align-center ml-2"
                >
                  <div class="d-flex" style="margin-right: 10px;">
                    <v-checkbox
                      :value="rowIndexColorPaletteCluster == rowIndex"
                      color="#000"
                      @click="toggleColorPaletteCluster(rowIndex)"
                    ></v-checkbox>
                  </div>
                  <div class="d-flex">
                    <v-row class="color-row" align="center" justify="start" no-gutters>
                      <v-col v-for="(color, index) in row" :key="index" cols="auto">
                        <div :style="{ backgroundColor: color }" class="color-box"></div>
                      </v-col>
                    </v-row>
                  </div>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="rowIndex == 5"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        class="ml-2"
                        @click="dialogGeneratePalette = true"
                      >
                        <v-icon>mdi-palette</v-icon>
                      </v-btn>
                    </template>
                    <span>Custom Palette</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogModularity = false">
              Cancel
            </v-btn>
            <v-btn text @click="dialogModularity = false, updatedCommunityColorsModularity()">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogGeneratePalette" max-width="400">
        <v-card>
          <v-card-title class="d-flex align-center">
            <v-icon class="mr-2">mdi-palette</v-icon>
            Generate Palette
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="8" class="d-flex align-center">
                <span class="mt-2 mr-2">Limit number of colors :</span>
              </v-col>
            </v-row>

            <v-row class="mt-2" align="center" no-gutters>
              <v-text-field
                v-model="colorCount"
                dense
                outlined
                hide-details
                type="number"
                style="max-width: 60px; margin-right: 10px;"
              ></v-text-field>

              <v-btn class="ml-1" height="40" outlined @click="generatePalette">
                Generate Color
              </v-btn>
            </v-row>

            <v-row>
              <v-col cols="12">
                <div class="palette-preview">
                  <div
                    v-for="(color, index) in generatedColors"
                    :key="index"
                    :style="{ backgroundColor: color }"
                    class="color-boxGeneratedColors"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogGeneratePalette = false">
              Cancel
            </v-btn>
            <v-btn :disabled="generatedColors.length == 0" text @click="okGeneratePalette">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">Loading content, please wait</v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialog = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Graph from "graphology";
import Sigma from "sigma";
import FA2Layout from "graphology-layout-forceatlas2/worker";
import louvain from "graphology-communities-louvain";
import { circular } from "graphology-layout";
// import { random } from 'graphology-layout';
import { circlepack } from "graphology-layout";
import { rotation } from 'graphology-layout';
import { NodeBorderProgram } from "@sigma/node-border";
import { animateNodes } from "sigma/utils";
import EdgeCurvedArrowProgram from "@sigma/edge-curve";
import Vue from 'vue';
import axios from "axios";
import SliderComponent from "@/components/SliderComponent.vue";
import SliderComponentEdges from "@/components/SliderComponentEdges.vue"; 
import iwanthue from "iwanthue";
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiCircleOpacity } from '@mdi/js';

let cancelCurrentAnimation = null;

export default {
  components: {
    SliderComponent,
    SliderComponentEdges,
    SvgIcon
  },
  data() {
    return {
      openOpacity: false,
      pathIconOpacity: mdiCircleOpacity,
      dialog: false,
      dialogCluster: false,
      dialogHypergraphCluster: false,
      panels: ["Community", "Layout", "Advanced"],
      panelsHypergraph: ["Community", "Advanced"],
      isCheckAll: true,
      clusters: [],
      graphColorClusters: [],
      itemsLayout: ["Force Atlas 2", "Circular", "Circle Pack"],
      selectedLayout: "Force Atlas 2",
      itemsAdvanced: "",
      itemsNodeSize: [
        {
          name: 'In Degree',
          value: 'In_degree',
        },
        {
          name: 'Out Degree',
          value: 'Out_degree',
        },
        {
          name: 'Degree',
          value: 'degree',
        },
        {
          name: 'Betweenness',
          value: 'betweenness',
        },
        {
          name: 'Closeness',
          value: 'closeness',
        },
        {
          name: 'Eigenvector',
          value: 'eigenvector',
        }
      ],
      selectedNodeSize: "",
      sliderNodeSize: [2, 10],
      valueEdgesWeights: true,
      sliderEdgesSize: [1, 1],
      selectedEdgesStyle: "",
      rowIndexColorPaletteCluster: "",
      colorPaletteCluster: [
        ["#533dfc", "#02ad2a", "#d41500", "#7d039e", "#bd8319", "#c105f5", "#9e0000", "#035c1d", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3"],
        ["#bd8319", "#533dfc", "#02ad2a", "#9e0000", "#c105f5", "#035c1d", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3"],
        ["#035c1d", "#c105f5", "#d41500", "#035c1d", "#533dfc", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3"],
        ["#533dfc", "#d41500", "#035c1d", "#c105f5", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3"],
        ["#fc288f", "#28b9fc", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3"],
        ["#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3", "#D3D3D3"],
      ],
      colorPalette: ["#d54539", "#5b77b6", "#c27640", "#cdcb9e", "#dca93e", "#6ed349", "#838837", "#6ccfbe", "#a248d5", "#c9438b", "#45294b", "#75cf83", "#447647", "#474938", "#c48a92", "#89b0c9", "#543a9c", "#7d3232", "#ccda4d", "#c288d1"],
      isClusterModularity: false,
      dialogModularity: false,
      settingsModularity: "",
      modularityScore: "",
      dialogGeneratePalette: false,
      isSelectCustomPalette: false,
      limitColors: true,
      colorCount: 10,
      generatedColors: [],
      generatedColorsCluster: "",
      dialogFullScreen: false,
      selectedTopic: "",
      selectedPeriode: "Last 7 Days",
      valueSelectedPeriode: "Last 7 Days",
      selectedTypeGraph: "bigram",
      selectedSource: "",
      isStartStop: false,
      graphData: "",
      graph: null,
      renderer: null,
      layout: null,
      state: {
        hoveredNode: null,
        hoveredNeighbors: null,
      },
      showLabels: true,
    };
  },
  mounted() {
    this.initializeGraph();
  },
  methods: {
    updateHypergraphOpacity(value) {
      if (window.updateGroupColors) {
        window.updateGroupColors(parseFloat(value));
      }
    },
    handleInputModularityScore() {
      const detailedOutput = louvain.detailed(this.graph, {
        resolution: this.settingsModularity.resolution,
        randomWalk: this.settingsModularity.randomize,
      });

      const { modularity } = detailedOutput;

      if (this.settingsModularity.resolution != "") {
        this.modularityScore = modularity.toFixed(4);
      }

      if (this.settingsModularity.resolution == "") {
        this.modularityScore = "";
      }
    },
    generateRandomColor() {
      let color;
      do {
        color = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
      } while (color.toUpperCase() == '#D3D3D3');
      return color;
    },
    generatePalette() {
      let colorSet = new Set();
      while (colorSet.size < this.colorCount) {
        colorSet.add(this.generateRandomColor());
      }
      this.generatedColors = Array.from(colorSet);
    },
    okGeneratePalette() {
      this.generatedColorsCluster = [...this.generatedColors];
      while (this.generatedColorsCluster.length < 15) {
        this.generatedColorsCluster.push("#D3D3D3");
      }

      this.colorPaletteCluster[5] = this.generatedColorsCluster.slice(0, 15);
      this.dialogGeneratePalette = false;
    },
    applyDialogGeneratePalette() {
      this.isClusterModularity = true;

      const communities = louvain(this.graph, {
        resolution: this.settingsModularity.resolution,
        randomWalk: this.settingsModularity.randomize,
      });

      const communitySizes = {};
      const clusterInDegrees = {};

      this.graph.forEachNode((node) => {
        const communityId = communities[node];
        communitySizes[communityId] = (communitySizes[communityId] || 0) + 1;

        const inDegree = this.getInDegreeById(node);
        clusterInDegrees[communityId] = (clusterInDegrees[communityId] || 0) + inDegree;
      });

      const totalNodes = this.graph.order;
      const sortedClusterIds = Object.entries(communitySizes)
        .map(([id, size]) => ({
          id: Number(id),
          percentage: (size / totalNodes) * 100,
        }))
        .sort((a, b) => b.percentage - a.percentage)
        .map(({ id }) => id);

      const assignedColors = {};

      sortedClusterIds.forEach((communityId, index) => {
        assignedColors[communityId] = index < this.colorCount ? this.generatedColors[index] : "#D3D3D3";
      });

      this.graph.forEachNode((node) => {
        const communityId = communities[node];
        const color = assignedColors[communityId] || "#D3D3D3";

        this.graph.setNodeAttribute(node, "color", color);
      });

      this.renderer.refresh();

      this.clusters = [];
      this.graphColorClusters = [];

      this.graph.forEachNode((node) => {
        const communityId = communities[node];
        const label = this.getLabelById(node);
        const inDegree = this.getInDegreeById(node);

        if (!clusterInDegrees[communityId]) {
          clusterInDegrees[communityId] = 0;
        }

        this.clusters.push({
          name: communityId,
          label: label,
          in_degree: inDegree,
          totalIn_degree: clusterInDegrees[communityId],
          color: "",
          checked: true,
          percentage: ((communitySizes[communityId] / totalNodes) * 100).toFixed(2),
        });
      });

      const groupedClusters = this.clusters.reduce((acc, cluster) => {
        if (!acc[cluster.name] || acc[cluster.name].in_degree < cluster.in_degree) {
          acc[cluster.name] = cluster;
        }
        return acc;
      }, {});

      this.clusters = Object.values(groupedClusters);
      this.clusters.sort((a, b) => b.percentage - a.percentage);

      this.clusters.forEach((cluster) => {
        const color = assignedColors[cluster.name] || "#D3D3D3";
        cluster.color = color;

        if (!this.graphColorClusters.find((item) => item.name == cluster.name)) {
          this.graphColorClusters.push({ color, name: cluster.name });
        }
      });

      this.dialogGeneratePalette = false;
    },
    toggleColorPaletteCluster(rowIndex) {
      this.rowIndexColorPaletteCluster = rowIndex;
      if (rowIndex != 5) {
        this.isSelectCustomPalette = false;
      }
      if (rowIndex == 5) {
        this.isSelectCustomPalette = true;
      }
    },
    updatedCommunityColorsModularity() {
      if (this.isSelectCustomPalette == true) {
        this.applyDialogGeneratePalette();
      }
      if (this.isSelectCustomPalette == false) {
        this.isClusterModularity = true;

        const communities = louvain(this.graph, {
          resolution: this.settingsModularity.resolution,
          randomWalk: this.settingsModularity.randomize,
        });

        const communitySizes = {};
        const clusterInDegrees = {};

        this.graph.forEachNode((node) => {
          const communityId = communities[node];
          communitySizes[communityId] = (communitySizes[communityId] || 0) + 1;

          const inDegree = this.getInDegreeById(node);
          clusterInDegrees[communityId] = (clusterInDegrees[communityId] || 0) + inDegree;
        });

        const totalNodes = this.graph.order;
        const sortedClusterIds = Object.entries(communitySizes)
          .map(([id, size]) => ({
            id: Number(id),
            percentage: (size / totalNodes) * 100,
          }))
          .sort((a, b) => b.percentage - a.percentage)
          .map(({ id }) => id);

        const colorPalette = this.colorPaletteCluster[this.rowIndexColorPaletteCluster];
        const assignedColors = {};

        this.graph.forEachNode((node) => {
          const communityId = communities[node];
          const colorIndex = sortedClusterIds.indexOf(communityId);
          const color = colorIndex < colorPalette.length ? colorPalette[colorIndex] : "#D3D3D3";

          this.graph.setNodeAttribute(node, "color", color);
          assignedColors[communityId] = color;
        });

        this.renderer.refresh();

        this.clusters = [];
        this.graphColorClusters = [];

        this.graph.forEachNode((node) => {
          const communityId = communities[node];
          const label = this.getLabelById(node);
          const inDegree = this.getInDegreeById(node);

          if (!clusterInDegrees[communityId]) {
            clusterInDegrees[communityId] = 0;
          }

          this.clusters.push({
            name: communityId,
            label: label,
            in_degree: inDegree,
            totalIn_degree: clusterInDegrees[communityId],
            color: "",
            checked: true,
            percentage: ((communitySizes[communityId] / totalNodes) * 100).toFixed(2),
          });
        });

        const groupedClusters = this.clusters.reduce((acc, cluster) => {
          if (!acc[cluster.name] || acc[cluster.name].in_degree < cluster.in_degree) {
            acc[cluster.name] = cluster;
          }
          return acc;
        }, {});

        this.clusters = Object.values(groupedClusters);

        this.clusters.sort((a, b) => b.percentage - a.percentage);

        this.clusters.forEach((cluster) => {
          const color = assignedColors[cluster.name] || "#D3D3D3";
          cluster.color = color;

          if (!this.graphColorClusters.find((item) => item.name == cluster.name)) {
            this.graphColorClusters.push({ color, name: cluster.name });
          }
        });
      }
    },
    clickCheckAll() {
      if (this.isCheckAll == true) {
        this.checkAll();
      }
      if (this.isCheckAll == false) {
        this.uncheckAll();
      }
    },
    checkAll() {
      this.clusters.forEach((cluster) => (cluster.checked = true));

      if (this.renderer) {
        const graph = this.graph;

        if (graph) {
          graph.forEachNode((node) => {
            graph.setNodeAttribute(node, "hidden", false);
          });

          graph.forEachEdge((edge) => {
            graph.setEdgeAttribute(edge, "hidden", false);
          });

          this.renderer.refresh();
        }
      }
    },
    uncheckAll() {
      this.clusters.forEach((cluster) => (cluster.checked = false));

      if (this.renderer) {
        const graph = this.renderer.getGraph();

        graph.forEachNode((node) => {
          graph.setNodeAttribute(node, "hidden", true);
        });

        graph.forEachEdge((edge) => {
          graph.setEdgeAttribute(edge, "hidden", true);
        });

        this.renderer.refresh();
      }
      this.stopLayout();
    },
    toggleCluster(clusterName) {
      if (this.renderer) {
        const graph = this.renderer.getGraph();

        graph.forEachNode((node, attributes) => {
          if (attributes.community === parseInt(clusterName)) {
            graph.setNodeAttribute(node, "hidden", !attributes.hidden);
          }
        });

        graph.forEachEdge((edge, attributes) => {
          const sourceNode = graph.source(edge);
          const targetNode = graph.target(edge);

          const sourceCommunity = graph.getNodeAttributes(sourceNode).community;
          const targetCommunity = graph.getNodeAttributes(targetNode).community;

          if (sourceCommunity === clusterName || targetCommunity === clusterName) {
            graph.setEdgeAttribute(edge, "hidden", !attributes.hidden);
          }
        });

        this.renderer.refresh();
      }
    },
    applyLayout() {
      this.resetLayout();
      if (this.graph) {
        if (this.selectedLayout == "Force Atlas 2") {
          this.startLayout();
        }
        if (this.selectedLayout == "Circle Pack") {
          circlepack.assign(this.graph, {
            hierarchyAttributes: ["degree", "community"],
          });
        }
      }

      if (this.renderer) {
        this.renderer.refresh();
      }
    },
    dataSlider(data) {
      this.$set(this.sliderNodeSize, 0, data[0]);
      this.$set(this.sliderNodeSize, 1, data[1]);
    },
    dataSliderEdges(data) {
      this.$set(this.sliderEdgesSize, 0, data[0]);
      this.$set(this.sliderEdgesSize, 1, data[1]);
    },
    applyInitializeGraph() {
      const topN = 10;
      const data = this.graphData;

      if (data.nodes.length > 0) {
        if (!this.renderer) {
          const container = this.$el.querySelector("#sigma-container");
          this.renderer = new Sigma(this.graph, container, {
            defaultNodeType: "bordered",
            defaultEdgeType: this.selectedEdgesStyle == "straight" ? "arrow" : "curvedArrow",
            renderEdgeLabels: true,
            nodeProgramClasses: {
              bordered: NodeBorderProgram,
            },
            edgeProgramClasses: {
              curvedArrow: EdgeCurvedArrowProgram,
            },
          });

          this.attachSigmaReducers();
          this.attachEventListeners();
        }

        if (!this.graph) {
          this.graph = new Graph();
        } else {
          this.graph.clear();
        }

        if (this.valueEdgesWeights == false) {
          this.sliderEdgesSize[1] = this.sliderEdgesSize[0];
          Vue.set(this.sliderEdgesSize, 1, this.sliderEdgesSize[0]);
          this.graphData.edges.forEach((edge) => {
            edge[2] = 1;
          });
        }

        let edges = this.valueEdgesWeights ? this.graphData.originalEdges : this.graphData.edges;

        const minSize = this.sliderNodeSize[0];
        const maxSize = this.sliderNodeSize[1];

        let minWeight, maxWeight;
        if (this.selectedNodeSize == "In_degree") {
          minWeight = Math.min(...this.graphData.nodes.map((n) => n.in_degree));
          maxWeight = Math.max(...this.graphData.nodes.map((n) => n.in_degree));
        }
        if (this.selectedNodeSize == "Out_degree") {
          minWeight = Math.min(...this.graphData.nodes.map((n) => n.out_degree));
          maxWeight = Math.max(...this.graphData.nodes.map((n) => n.out_degree));
        }
        if (this.selectedNodeSize == "degree") {
          minWeight = Math.min(...this.graphData.nodes.map((n) => n.degree));
          maxWeight = Math.max(...this.graphData.nodes.map((n) => n.degree));
        }
        if (this.selectedNodeSize == "betweenness") {
          minWeight = Math.min(...this.graphData.nodes.map((n) => n.betweenness));
          maxWeight = Math.max(...this.graphData.nodes.map((n) => n.betweenness));
        }
        if (this.selectedNodeSize == "closeness") {
          minWeight = Math.min(...this.graphData.nodes.map((n) => n.closeness));
          maxWeight = Math.max(...this.graphData.nodes.map((n) => n.closeness));
        }
        if (this.selectedNodeSize == "eigenvector") {
          minWeight = Math.min(...this.graphData.nodes.map((n) => n.eigenvector));
          maxWeight = Math.max(...this.graphData.nodes.map((n) => n.eigenvector));
        }

        this.graphData.nodes.forEach((node) => {
          const weight =
            this.selectedNodeSize == "In_degree"
              ? node.in_degree
              : this.selectedNodeSize == "Out_degree"
              ? node.out_degree
              : this.selectedNodeSize == "Degree"
              ? node.degree
              : this.selectedNodeSize == "betweenness"
              ? node.betweenness
              : this.selectedNodeSize == "closeness"
              ? node.closeness
              : node.eigenvector;

          const nodeSize = minSize + ((weight - minWeight) / (maxWeight - minWeight)) * (maxSize - minSize);

          if (!this.graph.hasNode(node.id)) {
            this.graph.addNode(node.id, {
              label: node.label,
              weight: weight,
              x: node.x,
              y: node.y,
              size: nodeSize,
              borderColor: "#000",
            });
          } else {
            console.log(`Node with ID "${node.id}" already exists. Skipping.`);
          }
        });

        edges.forEach(([source, target, weight]) => {
          const minEdgeSize = this.sliderEdgesSize[0];
          const maxEdgeSize = this.sliderEdgesSize[1];

          const weights = edges.map(([, , weight]) => weight);
          const minWeight = Math.min(...weights);
          const maxWeight = Math.max(...weights);

          let edgeSize = minEdgeSize + ((weight - minWeight) / (maxWeight - minWeight)) * (maxEdgeSize - minEdgeSize);
          if (minWeight == maxWeight) {
            edgeSize = minEdgeSize;
          }
          if (minEdgeSize == maxEdgeSize) {
            edgeSize = minEdgeSize;
          }

          this.graph.addEdge(source, target, {
            type: this.selectedEdgesStyle == "straight" ? "arrow" : "curvedArrow",
            size: edgeSize,
          });
        });

        const communities = louvain(this.graph, {
          resolution: this.settingsModularity.resolution,
          randomWalk: this.settingsModularity.randomize,
        });

        this.graph.forEachNode((node) => {
          const communityId = communities[node];
          this.graph.setNodeAttribute(node, "community", communityId);
        });

        const clusterInDegrees = {};
        this.graph.forEachNode((node) => {
          const communityId = communities[node];
          const inDegree = this.getInDegreeById(node);
          clusterInDegrees[communityId] = (clusterInDegrees[communityId] || 0) + inDegree;
        });
        const sortedClusterIds = Object.entries(clusterInDegrees)
          .sort(([, totalInDegreeA], [, totalInDegreeB]) => totalInDegreeB - totalInDegreeA)
          .slice(0, topN)
          .map(([id]) => Number(id));

        const colorPalette = this.colorPaletteCluster[this.rowIndexColorPaletteCluster];
        if (this.isClusterModularity == true) {
          this.graph.forEachNode((node) => {
            const communityId = communities[node];
            const colorIndex = sortedClusterIds.indexOf(communityId);
            const color = colorIndex < colorPalette.length
              ? colorPalette[colorIndex]
              : "#D3D3D3";
            this.graph.setNodeAttribute(node, "color", color);
          });
        }
        if (this.isClusterModularity == false && this.clusters.length != 0) {
          this.graph.forEachNode((node) => {
            const communityId = communities[node];
            const colorIndex = sortedClusterIds.indexOf(communityId);
            const color = colorIndex < this.colorPalette.length
              ? this.colorPalette[colorIndex]
              : "#D3D3D3";
            this.graph.setNodeAttribute(node, "color", color);
          });
        }

        this.renderer.refresh();
        this.resetLayout();
        if (this.selectedLayout == "Circular") {
          if (cancelCurrentAnimation) cancelCurrentAnimation();

          const circularPositions = circular(this.graph, { scale: 100 });

          cancelCurrentAnimation = animateNodes(this.graph, circularPositions, {
            duration: 2000,
            easing: "linear",
          });
        }
        if (this.selectedLayout == "Circle Pack") {
          circlepack.assign(this.graph, {
            hierarchyAttributes: ["degree", "community"],
          });
        }
      }
    },
    exitFullScreen() {
      window.parent.postMessage('closeFullscreen', '*');
    },
    zoomIn() {
      if (this.renderer) {
        const camera = this.renderer.getCamera();
        camera.setState({
          ratio: camera.ratio * 0.8,
        });
      }
    },
    zoomOut() {
      if (this.renderer) {
        const camera = this.renderer.getCamera();
        camera.setState({
          ratio: camera.ratio * 1.2,
        });
      }
    },
    rotationLayout() {
      this.stopLayout();
      if (cancelCurrentAnimation) cancelCurrentAnimation();

      const rotationPositions = rotation(this.graph, Math.PI / 6, { centeredOnZero: true });

      cancelCurrentAnimation = animateNodes(this.graph, rotationPositions, {
        duration: 2000,
        easing: "linear",
      });
    },
    async initializeGraph() {
      this.dialog = true;
      try {
        this.selectedTopic = this.$route.query.selectedtopic;
        this.selectedPeriode = this.$route.query.selectedperiode;
        this.selectedTypeGraph = this.$route.query.selectedtypegraph;
        this.selectedSource = this.$route.query.selectedSource;
        this.selectedNodeSize = this.$route.query.selectednodesize;
        Vue.set(this, 'sliderNodeSize', this.$route.query.slidernodesize.split(',').map(Number));
        this.valueEdgesWeights = this.$route.query.valueedgesweights;
        this.sliderEdgesSize = this.$route.query.slideredgessize.split(',').map(Number);
        this.selectedEdgesStyle = this.$route.query.selectededgesstyle;
        this.settingsModularity = this.$route.query.settingsModularity;
        if (this.selectedPeriode == "Today") {
          this.valueSelectedPeriode = "TODAY";
        }
        if (this.selectedPeriode == "From Yesterday") {
          this.valueSelectedPeriode = "FROM_YESTERDAY";
        }
        if (this.selectedPeriode == "This Week") {
          this.valueSelectedPeriode = "THIS_WEEK";
        }
        if (this.selectedPeriode == "Previous Week") {
          this.valueSelectedPeriode = "PREVIOUS_WEEK";
        }
        if (this.selectedPeriode == "This Month") {
          this.valueSelectedPeriode = "THIS_MONTH";
        }
        if (this.selectedPeriode == "Previous Month") {
          this.valueSelectedPeriode = "PREVIOUS_MONTH";
        }
        const axiosInstance = axios.create({ baseURL: '/apigraph' });
        const response = await axiosInstance.post('/generate_json', {
          topic: this.selectedTopic,
          proc_date: this.valueSelectedPeriode,
          type: this.selectedTypeGraph,
          collection: this.selectedSource
        });

        if (this.selectedTypeGraph == "bigram" || this.selectedTypeGraph == "person") {
          await this.$nextTick();

          this.itemsAdvanced = ["Node Size", "Node Size", "Edges Weights", "Edges Size", "Edges Style"];

          if (typeof response.data === 'string') {
            const sanitizedData = response.data.replace(/NaN/g, 'null');
            this.dataGraph = JSON.parse(sanitizedData);
          } else {
            this.dataGraph = response.data;
          }

          if (this.dataGraph.payload.nodes.length > 0) {
            this.dataGraph.payload.nodes.sort((a, b) => b.degree - a.degree);
            this.dataGraph.payload.nodes = this.dataGraph.payload.nodes.slice(0, 1000);

            const keptNodeIds = new Set(this.dataGraph.payload.nodes.map(node => node.id));

            this.dataGraph.payload.edges = this.dataGraph.payload.edges.filter(
              edge => keptNodeIds.has(edge[0]) && keptNodeIds.has(edge[1])
            );

            if (this.dataGraph.payload.edges.length > 1000) {
              this.dataGraph.payload.edges.sort((a, b) => b[2] - a[2]);
              this.dataGraph.payload.edges = this.dataGraph.payload.edges.slice(0, 1000);
            }

            if (this.renderer) {
              this.renderer.kill();
              this.renderer = null;
            }

            if (this.graph) {
              this.graph.clear();
              this.graph = null;
            }

            this.graphData = this.dataGraph.payload;
            this.graphData.originalEdges = JSON.parse(JSON.stringify(this.graphData.edges));
            this.graph = new Graph();
            if (this.valueEdgesWeights == false) {
              this.sliderEdgesSize[1] = this.sliderEdgesSize[0];
              Vue.set(this.sliderEdgesSize, 1, this.sliderEdgesSize[0]);
              this.graphData.edges.forEach((edge) => {
                edge[2] = 1;
              });
            }
            const edges = this.graphData.edges;

            this.graphData.nodes.forEach((node) => {
              const minSize = this.sliderNodeSize[0];
              const maxSize = this.sliderNodeSize[1];

              let minWeight, maxWeight;
              if (this.selectedNodeSize == "In_degree") {
                minWeight = Math.min(...this.graphData.nodes.map((n) => n.in_degree));
                maxWeight = Math.max(...this.graphData.nodes.map((n) => n.in_degree));
              }
              if (this.selectedNodeSize == "Out_degree") {
                minWeight = Math.min(...this.graphData.nodes.map((n) => n.out_degree));
                maxWeight = Math.max(...this.graphData.nodes.map((n) => n.out_degree));
              }
              if (this.selectedNodeSize == "degree") {
                minWeight = Math.min(...this.graphData.nodes.map((n) => n.degree));
                maxWeight = Math.max(...this.graphData.nodes.map((n) => n.degree));
              }
              if (this.selectedNodeSize == "betweenness") {
                minWeight = Math.min(...this.graphData.nodes.map((n) => n.betweenness));
                maxWeight = Math.max(...this.graphData.nodes.map((n) => n.betweenness));
              }
              if (this.selectedNodeSize == "closeness") {
                minWeight = Math.min(...this.graphData.nodes.map((n) => n.closeness));
                maxWeight = Math.max(...this.graphData.nodes.map((n) => n.closeness));
              }
              if (this.selectedNodeSize == "eigenvector") {
                minWeight = Math.min(...this.graphData.nodes.map((n) => n.eigenvector));
                maxWeight = Math.max(...this.graphData.nodes.map((n) => n.eigenvector));
              }

              const weight =
                this.selectedNodeSize == "In_degree"
                  ? node.in_degree
                  : this.selectedNodeSize == "Out_degree"
                  ? node.out_degree
                  : this.selectedNodeSize == "Degree"
                  ? node.degree
                  : this.selectedNodeSize == "betweenness"
                  ? node.betweenness
                  : this.selectedNodeSize == "closeness"
                  ? node.closeness
                  : node.eigenvector;

              const nodeSize = minSize + ((weight - minWeight) / (maxWeight - minWeight)) * (maxSize - minSize);

              if (!this.graph.hasNode(node.id)) {
                this.graph.addNode(node.id, {
                  label: node.label,
                  weight: weight,
                  x: node.x,
                  y: node.y,
                  size: nodeSize,
                  borderColor: "#000",
                });
              } else {
                console.log(`Node with ID "${node.id}" already exists. Skipping.`);
              }
            });

            edges.forEach(([source, target, weight]) => {
              const minSize = this.sliderEdgesSize[0];
              const maxSize = this.sliderEdgesSize[1];

              const weights = edges.map(([, , weight]) => weight);
              const minWeight = Math.min(...weights);
              const maxWeight = Math.max(...weights);

              let edgeSize = minSize + ((weight - minWeight) / (maxWeight - minWeight)) * (maxSize - minSize);
              if (minWeight == maxWeight) {
                edgeSize = minSize;
              }
              if (minSize == maxSize) {
                edgeSize = minSize;
              }

              if (!this.graph.hasEdge(source, target)) {
                this.graph.addEdge(source, target, {
                  type: this.selectedEdgesStyle == "straight" ? "arrow" : "curvedArrow",
                  size: edgeSize,
                });
              }
            });

            const communities = louvain(this.graph, {
              resolution: this.settingsModularity.resolution,
              randomWalk: this.settingsModularity.randomize,
            });

            this.graph.forEachNode((node) => {
              this.graph.setNodeAttribute(node, "community", communities[node]);
            });

            const container = this.$el.querySelector("#sigma-container");
            this.renderer = new Sigma(this.graph, container, {
              defaultNodeType: "bordered",
              defaultEdgeType: this.selectedEdgesStyle == "straight" ? "arrow" : "curvedArrow",
              renderEdgeLabels: true,
              nodeProgramClasses: {
                bordered: NodeBorderProgram,
              },
              edgeProgramClasses: {
                curvedArrow: EdgeCurvedArrowProgram,
              },
            });

            this.layout = new FA2Layout(this.graph, {
              settings: {
                gravity: 1,
                barnesHutOptimize: true,
                adjustSizes: true,
              },
            });

            this.attachSigmaReducers();
            this.attachEventListeners();

            const state = {
              hoveredNode: null,
              hoveredNeighbors: null,
              selectedNode: null,
              selectedNeighbors: null,
              isNodeSelected: false,
            };

            this.renderer.on("clickNode", ({ node }) => {
              if (state.selectedNode == node) {
                state.selectedNode = null;
                state.selectedNeighbors = null;
                state.isNodeSelected = false;
                this.selectedDescribeNode = "";
                this.responseDescribeNode = "";

                state.hoveredNode = null;
                state.hoveredNeighbors = null;
              } else {
                state.selectedNode = node;
                state.selectedNeighbors = new Set(this.graph.neighbors(node));
                state.isNodeSelected = true;
                this.selectedDescribeNode = node;

                state.hoveredNode = node;
                state.hoveredNeighbors = new Set(this.graph.neighbors(node));
              }

              this.renderer.refresh();
              this.postDescribeGraphNode();
            });

            this.renderer.on("clickStage", () => {
              state.selectedNode = null;
              state.selectedNeighbors = null;
              state.isNodeSelected = false;
              this.renderer.refresh();
            });

            this.renderer.setSetting("nodeReducer", (node, data) => {
              const res = { ...data };

              res.highlighted = this.selectedDescribeNode == node;

              if (state.isNodeSelected || state.hoveredNode) {
                if (state.hoveredNode) {
                  const isNeighbor = state.hoveredNeighbors && state.hoveredNeighbors.has(node);
                  if (!isNeighbor && state.hoveredNode !== node) {
                    res.hidden = true;
                  }
                }

                if (state.selectedNode) {
                  const isSelectedNeighbor = state.selectedNeighbors && state.selectedNeighbors.has(node);
                  if (!isSelectedNeighbor && state.selectedNode !== node) {
                    res.hidden = true;
                  }
                }

                if (state.selectedNode == node || state.hoveredNode == node) {
                  res.size = data.size * 1.2;
                }
              }

              return res;
            });

            this.renderer.setSetting("edgeReducer", (edge, data) => {
              const res = { ...data };
              const [source, target] = this.graph.extremities(edge);

              if (state.isNodeSelected || state.hoveredNode) {
                if (state.hoveredNode) {
                  if (source != state.hoveredNode && target != state.hoveredNode) {
                    res.hidden = true;
                  } else {
                    const nodeColor = this.graph.getNodeAttribute(state.hoveredNode, 'color');
                    const edgeWeight = this.graph.getEdgeAttribute(edge, "size") || 1;
                    res.color = nodeColor;
                    res.size = 1.5 * edgeWeight;
                  }
                }

                if (state.selectedNode) {
                  if (source != state.selectedNode && target != state.selectedNode) {
                    res.hidden = true;
                  } else {
                    res.size = data.size * 1.2;
                  }
                }
              } else {
                res.color = '#D3D3D3';
              }

              return res;
            });

            this.renderer.on("enterNode", ({ node }) => {
              state.hoveredNode = node;
              state.hoveredNeighbors = new Set(this.graph.neighbors(node));
              this.renderer.refresh();
            });

            this.renderer.on("leaveNode", () => {
              state.hoveredNode = null;
              state.hoveredNeighbors = null;
              this.renderer.refresh();
            });

            this.addDragAndDrop(this.graph, this.renderer);
          } else {
            this.alert = true;
            setTimeout(() => {
              this.alert = false;
            }, 10000);
            this.message = "API Generate JSON Response Data Not Found";
            this.colorAlert = "red";
            if (this.graph) {
              this.graph.clear();
              this.graph = null;
            }
            if (this.renderer) {
              this.renderer.kill();
              this.renderer = null;
            }
            this.clusters = [];
          }
        }

        if (this.selectedTypeGraph == "hypergraph") {
          if (this.graph) {
            this.graph.clear();
            this.graph = null;
          }

          this.itemsAdvanced = ["Node Size", "Node Size"];

          this.renderCanvasHypergraph(response.data.payload);
        }

        this.selectedLayout = this.$route.query.selectedlayout;
        if (this.selectedLayout == "Circular") {
          if (cancelCurrentAnimation) cancelCurrentAnimation();

          const circularPositions = circular(this.graph, { scale: 100 });

          cancelCurrentAnimation = animateNodes(this.graph, circularPositions, {
            duration: 2000,
            easing: "linear",
          });
        }
        if (this.selectedLayout == "Circle Pack") {
          circlepack.assign(this.graph, {
            hierarchyAttributes: ["degree", "community"],
          });
        }
        this.dialog = false;
      } catch (error) {
        console.error("Error initializing graph:", error);
        this.dialog = false;
      }
    },
    
    renderCanvasHypergraph(payload) {
      const oldCanvas = document.getElementById('canvasHypergraph');
      if (!oldCanvas) return;

      const canvas = document.createElement("canvas");
      canvas.id = "canvasHypergraph";
      oldCanvas.parentNode.replaceChild(canvas, oldCanvas);

      const ctx = canvas.getContext("2d");

      const container = canvas.parentElement;
      canvas.width = container.clientWidth;
      canvas.height = container.clientHeight;

      const nodes = payload.nodes;
      const groups = payload.groups;
      const personGroup = payload.person_group || [];
      const organizationGroup = payload.organization_group || [];

      let isDraggingCanvas = false;
      let lastX = 0, lastY = 0;
      let scale = 1;
      let panX = 0;
      let panY = 0;

      const boundary = 0.3;
      const min_X = Math.min(...nodes.map(obj => obj.x));
      const max_X = Math.max(...nodes.map(obj => obj.x));
      const min_Y = Math.min(...nodes.map(obj => obj.y));
      const max_Y = Math.max(...nodes.map(obj => obj.y));
      const center_X = canvas.width / 2;
      const center_Y = canvas.height / 2;
      const shift_X = center_X - (boundary + (nodes[0].x - min_X) / (max_X - min_X) * (1 - 2 * boundary)) * canvas.width;
      const shift_Y = center_Y - (boundary + (nodes[0].y - min_Y) / (max_Y - min_Y) * (1 - 2 * boundary)) * canvas.height;

      nodes.forEach((node) => {
        node.x = (boundary + (node.x - min_X) / (max_X - min_X) * (1 - 2 * boundary)) * canvas.width + shift_X;
        node.y = (1 - ((boundary + (node.y - min_Y) / (max_Y - min_Y) * (1 - 2 * boundary)) * canvas.height + shift_Y) / canvas.height) * canvas.height;
        node.radius = 8;
      });

      let palette = iwanthue(groups.length, {
        clustering: 'force-vector',
        seed: 'cool-palette',
        quality: 100,
        colorSpace: [0, 360, 60, 80, 0, 100],
      });

      function hexToRgba(hex, alpha = 0.1) {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      }

      groups.forEach((group, i) => {
        group.color = hexToRgba(palette[i], 0.1);
        group.borderColor = hexToRgba(palette[i], 1);
      });

      let activeGroup = null;
      let selectedNode = null;
      let offsetX, offsetY;

      function distanceBetween(x1, y1, x2, y2) {
        return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
      }

      function createGroupPath(nodeIds) {
        const groupNodes = nodes.filter(node => nodeIds.includes(node.id));

        if (groupNodes.length === 1) {
          const node = groupNodes[0];
          const path = new Path2D();
          path.arc(node.x, node.y, node.radius + 20, 0, Math.PI * 2);
          return path;
        } else if (groupNodes.length === 2) {
          const path = new Path2D();
          const node1 = groupNodes[0];
          const node2 = groupNodes[1];

          const angle = Math.atan2(node2.y - node1.y, node2.x - node1.x);
          const dist = distanceBetween(node1.x, node1.y, node2.x, node2.y);
          const padding = 30;

          const centerX = (node1.x + node2.x) / 2;
          const centerY = (node1.y + node2.y) / 2;

          const dirX = Math.cos(angle);
          const dirY = Math.sin(angle);
          const perpX = -dirY;
          const perpY = dirX;

          const halfLength = dist / 2 + padding;
          const width = padding + 10;

          const startX = centerX - halfLength * dirX + width * perpX;
          const startY = centerY - halfLength * dirY + width * perpY;

          path.moveTo(startX, startY);
          path.lineTo(centerX + halfLength * dirX + width * perpX,
                      centerY + halfLength * dirY + width * perpY);
          path.arc(centerX + halfLength * dirX,
                  centerY + halfLength * dirY,
                  width,
                  angle + Math.PI / 2,
                  angle + 3 * Math.PI / 2,
                  true);
          path.lineTo(centerX - halfLength * dirX - width * perpX,
                      centerY - halfLength * dirY - width * perpY);
          path.arc(centerX - halfLength * dirX,
                  centerY - halfLength * dirY,
                  width,
                  angle + 3 * Math.PI / 2,
                  angle + Math.PI / 2,
                  true);
          path.closePath();
          return path;
        } else if (groupNodes.length === 3) {
          const path = new Path2D();
          let node1 = groupNodes[0];
          let node2 = groupNodes[1];
          let node3 = groupNodes[2];

          if(((node2.x-node1.x)*(node3.y-node1.y)-(node2.y-node1.y)*(node3.x-node1.x)) > 0){
            node2 = groupNodes[2];
            node3 = groupNodes[1];
          }

          const padding = 50;
          const width = padding + 20 * (groupNodes.length - 1);

          const angle12 = Math.atan2(node2.y - node1.y, node2.x - node1.x);
          const angle23 = Math.atan2(node3.y - node2.y, node3.x - node2.x);
          const angle31 = Math.atan2(node1.y - node3.y, node1.x - node3.x);

          const dist12 = distanceBetween(node1.x, node1.y, node2.x, node2.y);
          const dist23 = distanceBetween(node2.x, node2.y, node3.x, node3.y);
          const dist31 = distanceBetween(node3.x, node3.y, node1.x, node1.y);

          const midX12 = (node1.x + node2.x) / 2;
          const midY12 = (node1.y + node2.y) / 2;
          const dirX12 = Math.cos(angle12);
          const dirY12 = Math.sin(angle12);
          const perpX12 = -dirY12;
          const perpY12 = dirX12;
          const halfLength12 = dist12 / 2;

          const midX23 = (node2.x + node3.x) / 2;
          const midY23 = (node2.y + node3.y) / 2;
          const dirX23 = Math.cos(angle23);
          const dirY23 = Math.sin(angle23);
          const perpX23 = -dirY23;
          const perpY23 = dirX23;
          const halfLength23 = dist23 / 2;

          const midX31 = (node3.x + node1.x) / 2;
          const midY31 = (node3.y + node1.y) / 2;
          const dirX31 = Math.cos(angle31);
          const dirY31 = Math.sin(angle31);
          const perpX31 = -dirY31;
          const perpY31 = dirX31;
          const halfLength31 = dist31 / 2;

          const corner1X = node1.x + width * perpX12;
          const corner1Y = node1.y + width * perpY12;

          path.moveTo(corner1X, corner1Y);
          path.lineTo(
            midX12 + halfLength12 * dirX12 + width * perpX12,
            midY12 + halfLength12 * dirY12 + width * perpY12
          );
          path.arc(
            node2.x,
            node2.y,
            width,
            angle12 + Math.PI / 2,
            angle23 + Math.PI / 2,
            true
          );
          path.lineTo(
            midX23 + halfLength23 * dirX23 + width * perpX23,
            midY23 + halfLength23 * dirY23 + width * perpY23
          );
          path.arc(
            node3.x,
            node3.y,
            width,
            angle23 + Math.PI / 2,
            angle31 + Math.PI / 2,
            true
          );
          path.lineTo(
            midX31 + halfLength31 * dirX31 + width * perpX31,
            midY31 + halfLength31 * dirY31 + width * perpY31
          );
          path.arc(
            node1.x,
            node1.y,
            width,
            angle31 + Math.PI / 2,
            angle12 + Math.PI / 2,
            true
          );
          path.closePath();
          return path;
        } else {
          const path = new Path2D();
          let sumX = 0, sumY = 0;
          groupNodes.forEach(node => {
            sumX += node.x;
            sumY += node.y;
          });

          const centerX = sumX / groupNodes.length;
          const centerY = sumY / groupNodes.length;

          groupNodes.forEach(node => {
            node.angle = Math.atan2(node.y - centerY, node.x - centerX);
          });
          groupNodes.sort((a, b) => b.angle - a.angle);

          const padding = 50;
          const width = padding + 20*(groupNodes.length-1);
          const nodeCount = groupNodes.length;

          const calculations = [];
          for (let i = 0; i < nodeCount; i++) {
              const currentNode = groupNodes[i];
              const nextNode = groupNodes[(i + 1) % nodeCount];

              const angle = Math.atan2(nextNode.y - currentNode.y, nextNode.x - currentNode.x);
              const dist = distanceBetween(currentNode.x, currentNode.y, nextNode.x, nextNode.y);

              const midX = (currentNode.x + nextNode.x) / 2;
              const midY = (currentNode.y + nextNode.y) / 2;
              const dirX = Math.cos(angle);
              const dirY = Math.sin(angle);
              const perpX = -dirY;
              const perpY = dirX;
              const halfLength = dist / 2;

              calculations.push({
                  currentNode,
                  nextNode,
                  angle,
                  dist,
                  midX,
                  midY,
                  dirX,
                  dirY,
                  perpX,
                  perpY,
                  halfLength
              });
          }

          const firstCalc = calculations[0];
          const corner1X = firstCalc.currentNode.x + width * firstCalc.perpX;
          const corner1Y = firstCalc.currentNode.y + width * firstCalc.perpY;

          path.moveTo(corner1X, corner1Y);

          for (let i = 0; i < nodeCount; i++) {
              const current = calculations[i];
              const next = calculations[(i + 1) % nodeCount];

              path.lineTo(
                  current.midX + current.halfLength * current.dirX + width * current.perpX,
                  current.midY + current.halfLength * current.dirY + width * current.perpY
              );

              path.arc(
                  current.nextNode.x,
                  current.nextNode.y,
                  width,
                  current.angle + Math.PI/2,
                  next.angle + Math.PI/2,
                  true
              );
          }

          path.closePath();
          return path;
        }
      }

      function drawHypergraph() {
          ctx.setTransform(1, 0, 0, 1, 0, 0); // Reset
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.setTransform(scale, 0, 0, scale, panX, panY); // Apply zoom and pan

          // Update group paths
          groups.forEach(group => {
              group.path = createGroupPath(group.nodes);
          });
          
          // Draw groups
          groups.forEach(group => {
              ctx.fillStyle = group.color;
              ctx.strokeStyle = group === activeGroup ? group.borderColor : 'rgba(0, 0, 0, 0.2)';
              ctx.lineWidth = group === activeGroup ? 2 : 1;
              
              ctx.fill(group.path);
              ctx.stroke(group.path);
          });
          
          // Draw nodes
          nodes.forEach(node => {
              const isHighlighted = activeGroup && activeGroup.nodes.includes(node.id);
              
              ctx.beginPath();
      ctx.arc(node.x, node.y, node.radius, 0, Math.PI * 2);
              
              if (personGroup.includes(node.label)){
                  ctx.fillStyle = isHighlighted ? '#b04b48' : 'black';
              } else if (organizationGroup.includes(node.label)){
                  ctx.fillStyle = isHighlighted ? '#85ca68' : 'black';            
              } else {
                  ctx.fillStyle = isHighlighted ? '#0070b7' : 'black';
              }
              
              ctx.fill();
              
              ctx.strokeStyle = "#000";
              ctx.lineWidth = 1;
              ctx.stroke();
              
              ctx.fillStyle = "black";
              ctx.font = "12px Arial";
              ctx.textAlign = "left";
              ctx.textBaseline = "middle";
              ctx.fillText(node.label, node.x + node.radius + 5, node.y);
          });
      }

      // Mouse event handlers
      canvas.addEventListener('mousemove', (e) => {
        if (this.dataGraph != "") {
          const rect = canvas.getBoundingClientRect();
          const scaleX = canvas.width / rect.width;  
          const scaleY = canvas.height / rect.height; 
          const mouseX = (e.clientX - rect.left) * scaleX;
          const mouseY = (e.clientY - rect.top) * scaleY;
          const x = (mouseX - panX) / scale;
          const y = (mouseY - panY) / scale;

          let isHoveringNode = false;

          // Dragging node
          if (selectedNode) {
              selectedNode.x = x - offsetX;
              selectedNode.y = y - offsetY;
              drawHypergraph();
              return;
          }

          // Dragging the entire canvas
          if (isDraggingCanvas) {
              const dx = e.clientX - lastX;
              const dy = e.clientY - lastY;
              panX += dx;
              panY += dy;
              lastX = e.clientX;
              lastY = e.clientY;
              drawHypergraph();
              return;
          }

          // Check if hovering over a node
          for (let i = 0; i < nodes.length; i++) {
              const node = nodes[i];
              const distance = distanceBetween(x, y, node.x, node.y);
              
              if (distance <= node.radius) {
                  isHoveringNode = true;
                  break;
              }
          }

          canvas.style.cursor = isHoveringNode ? "pointer" : "default";

          // Create a copy of groups array for sorting
          let sortedGroups = [...groups];
          sortedGroups.sort((a, b) => a.nodes.length - b.nodes.length);

          // Check if mouse is over any group
          let hoveredGroup = null;
          for (let i = 0; i < sortedGroups.length; i++) {
              const group = sortedGroups[i];
              if (ctx.isPointInPath(group.path, mouseX, mouseY)) {
                  hoveredGroup = group;
                  break;
              }
          }

          if (hoveredGroup !== activeGroup) {
              activeGroup = hoveredGroup;
              drawHypergraph();
          }        
        }
      });

      canvas.addEventListener('mousedown', (e) => {
        if (this.dataGraph != "") {
          const rect = canvas.getBoundingClientRect();
          const scaleX = canvas.width / rect.width;  
          const scaleY = canvas.height / rect.height; 
          const mouseX = (e.clientX - rect.left) * scaleX;
          const mouseY = (e.clientY - rect.top) * scaleY;
          const x = (mouseX - panX) / scale;
          const y = (mouseY - panY) / scale;
          
          let clickedOnNode = false;

          for (let i = 0; i < nodes.length; i++) {
              const node = nodes[i];
              const distance = distanceBetween(x, y, node.x, node.y);
              if (distance <= node.radius) {
                  selectedNode = node;
                  offsetX = x - node.x;
                  offsetY = y - node.y;
                  clickedOnNode = true;
                  break;
              }
          }

          if (!clickedOnNode) {
              isDraggingCanvas = true;
              lastX = e.clientX;
              lastY = e.clientY;
          }
        }
      });

      window.addEventListener('mouseup', () => {
        if (this.dataGraph != "") {
          selectedNode = null;
          isDraggingCanvas = false;
        }
      });

      canvas.addEventListener('mouseleave', () => {
        if (this.dataGraph != "") {
          selectedNode = null;
          activeGroup = null;
          drawHypergraph();
        }
      });

      canvas.addEventListener('wheel', (e) => {
        e.preventDefault();

        const rect = canvas.getBoundingClientRect();
        const mouseX = (e.clientX - rect.left - panX) / scale;
        const mouseY = (e.clientY - rect.top - panY) / scale;

        const zoomFactor = 1.1;
        const direction = e.deltaY > 0 ? 1 / zoomFactor : zoomFactor;

        const newScale = scale * direction;
        panX -= (mouseX * newScale - mouseX * scale);
        panY -= (mouseY * newScale - mouseY * scale);
        scale = newScale;
        
        drawHypergraph();
    }, { passive: false });

        // Handle window resize
        window.addEventListener('resize', () => {
            const oldWidth = canvas.width;
            const oldHeight = canvas.height;
            
            canvas.width = container.clientWidth;
            canvas.height = container.clientHeight;
            
            const scaleX = canvas.width / oldWidth;
            const scaleY = canvas.height / oldHeight;
            
            nodes.forEach(node => {
                node.x *= scaleX;
                node.y *= scaleY;
            });
            
            drawHypergraph();
        });

        // Initial draw
        drawHypergraph();

        // Make updateGroupColors function available globally
        window.updateGroupColors = function(alpha) {
            const rgbaPalette = palette.map((color) => hexToRgba(color, alpha));
            const borderPalette = palette.map((color) => hexToRgba(color, 1));

            groups.forEach((group, i) => {
                group.color = rgbaPalette[i];
                group.borderColor = borderPalette[i];
            });

            drawHypergraph();
        };
    },

    updateCommunityColors(topN) {

      const communities = louvain(this.graph, {
        resolution: this.settingsModularity.resolution,
        randomWalk: this.settingsModularity.randomize,
      });

      const communitySizes = {};
      this.graph.forEachNode((node) => {
        const communityId = communities[node];
        communitySizes[communityId] = (communitySizes[communityId] || 0) + 1;
      });

      const sortedCommunities = Object.entries(communitySizes)
        .sort(([, sizeA], [, sizeB]) => sizeB - sizeA)
        .slice(0, topN);

      const topCommunities = new Set(sortedCommunities.map(([id]) => Number(id)));

      this.updatedCommunityColors = {};
      this.graph.forEachNode((node) => {
        const communityId = communities[node];
        if (topCommunities.has(communityId)) {
          const colorIndex = [...topCommunities].indexOf(communityId);
          const color = this.colorPalette[colorIndex % this.colorPalette.length];
          this.graph.setNodeAttribute(node, "color", color);
          this.updatedCommunityColors[communityId] = color;
        } else {
          this.graph.setNodeAttribute(node, "color", "#D3D3D3");
          this.updatedCommunityColors[communityId] = "#666666";
        }
      });

      this.renderer.refresh();
    },

    attachSigmaReducers() {
      this.renderer.setSetting("nodeReducer", (node, data) => {
        const res = { ...data };
        if (this.state.hoveredNode) {
          if (this.state.hoveredNeighbors && !this.state.hoveredNeighbors.has(node) && this.state.hoveredNode !== node) {
            res.label = this.showLabels ? "" : null;
            res.color = "#f6f6f6";
          }
        }
        return res;
      });

      this.renderer.setSetting("edgeReducer", (edge, data) => {
        const res = { ...data };
        const [source] = this.graph.extremities(edge);
        if (this.state.hoveredNode && !this.state.hoveredNeighbors?.has(source)) {
          res.hidden = true;
        }
        return res;
      });
    },

    attachEventListeners() {
      this.renderer.on("enterNode", ({ node }) => {
        this.state.hoveredNode = node;
        this.state.hoveredNeighbors = new Set(this.graph.neighbors(node));
        this.renderer.refresh();
      });

      this.renderer.on("leaveNode", () => {
        this.state.hoveredNode = null;
        this.state.hoveredNeighbors = null;
        this.renderer.refresh();
      });
    },

    startLayout() {
      this.isStartStop = true;

      if (this.selectedLayout == "Force Atlas 2") {
        if (this.isClusterModularity == true) {
          this.updatedCommunityColorsModularity();
          this.layout.start();

          const camera = this.renderer.getCamera();

          const currentZoom = camera.getState().ratio;
          console.log("Current Zoom:", currentZoom);

          const newZoom = currentZoom * 0.2;
          console.log("New Zoom:", newZoom);

          const maxZoom = 0.2;

          if (currentZoom <= maxZoom) {
            this.isMaxZoomReached = true;
          } else {
            this.isMaxZoomReached = false;
          }

          if (this.isMaxZoomReached && this.lastZoom) {
            camera.setState({
              ratio: this.lastZoom,
            });
          } else {
            this.lastZoom = Math.max(newZoom, maxZoom);

            camera.animate(
              {
                ratio: this.lastZoom,
              },
              {
                duration: 5000,
                easing: "linear",
              }
            );
          }

          setTimeout(() => {
            this.stopLayout();
          }, 60000);
        }
        if (this.isClusterModularity == false) {
          this.startForceAtlas2Colors(10);
          this.layout.start();

          const camera = this.renderer.getCamera();

          const currentZoom = camera.getState().ratio;
          console.log("Current Zoom:", currentZoom);

          const newZoom = currentZoom * 0.2;
          console.log("New Zoom:", newZoom);

          const maxZoom = 0.2;

          if (currentZoom <= maxZoom) {
            this.isMaxZoomReached = true;
          } else {
            this.isMaxZoomReached = false;
          }

          if (this.isMaxZoomReached && this.lastZoom) {
            camera.setState({
              ratio: this.lastZoom,
            });
          } else {
            this.lastZoom = Math.max(newZoom, maxZoom);

            camera.animate(
              {
                ratio: this.lastZoom,
              },
              {
                duration: 5000,
                easing: "linear",
              }
            );
          }

          setTimeout(() => {
            this.stopLayout();
          }, 60000);
        }
      }
      if (this.selectedLayout == "Circular") {
        if (cancelCurrentAnimation) cancelCurrentAnimation();

        const circularPositions = circular(this.graph, { scale: 100 });

        cancelCurrentAnimation = animateNodes(this.graph, circularPositions, {
          duration: 2000,
          easing: "linear",
        });
      }
      if (this.selectedLayout == "Random") {
        const randomLayout = () => {
          if (cancelCurrentAnimation) cancelCurrentAnimation();

          const xExtents = { min: 0, max: 0 };
          const yExtents = { min: 0, max: 0 };
          this.graph.forEachNode((_node, attributes) => {
            xExtents.min = Math.min(attributes.x, xExtents.min);
            xExtents.max = Math.max(attributes.x, xExtents.max);
            yExtents.min = Math.min(attributes.y, yExtents.min);
            yExtents.max = Math.max(attributes.y, yExtents.max);
          });

          const randomPositions = {};
          this.graph.forEachNode((node) => {
            randomPositions[node] = {
              x: Math.random() * (xExtents.max - xExtents.min) + xExtents.min,
              y: Math.random() * (yExtents.max - yExtents.min) + yExtents.min,
            };
          });

          cancelCurrentAnimation = animateNodes(this.graph, randomPositions, { duration: 2000 });
        };

        randomLayout();
      }
      if (this.selectedLayout == "Rotation") {
        if (cancelCurrentAnimation) cancelCurrentAnimation();

        const rotationPositions = rotation(this.graph, Math.PI / 2, { centeredOnZero: true });

        cancelCurrentAnimation = animateNodes(this.graph, rotationPositions, {
          duration: 2000,
          easing: "linear",
        });
      }
    },
    startForceAtlas2Colors(topN) {
      const communities = louvain(this.graph, {
        resolution: this.settingsModularity.resolution,
        randomWalk: this.settingsModularity.randomize,
      });

      const communitySizes = {};
      this.graph.forEachNode((node) => {
        const communityId = communities[node];
        communitySizes[communityId] = (communitySizes[communityId] || 0) + 1;
      });

      const totalNodes = this.graph.order;
      let clustersData = Object.entries(communitySizes).map(([id, size]) => ({
        name: Number(id),
        percentage: ((size / totalNodes) * 100).toFixed(2),
      }));

      clustersData.sort((a, b) => b.percentage - a.percentage);
      const sortedClusterIds = clustersData.slice(0, topN).map(c => c.name);

      this.updatedCommunityColors = {};
      this.graph.forEachNode((node) => {
        const communityId = communities[node];
        const colorIndex = sortedClusterIds.indexOf(communityId);
        const color = colorIndex !== -1 ? this.colorPalette[colorIndex] : "#D3D3D3";
        this.graph.setNodeAttribute(node, "color", color);
        this.updatedCommunityColors[communityId] = color;
      });

      this.renderer.refresh();

      this.clusters = [];
      this.graphColorClusters = [];

      this.graph.forEachNode((node) => {
        const communityId = communities[node];
        const label = this.getLabelById(node);
        const inDegree = this.getInDegreeById(node);

        this.clusters.push({
          name: communityId,
          label: label,
          in_degree: inDegree,
          color: "",
          checked: true,
          percentage: ((communitySizes[communityId] / totalNodes) * 100).toFixed(2),
        });
      });

      const groupedClusters = this.clusters.reduce((acc, cluster) => {
        if (!acc[cluster.name] || acc[cluster.name].in_degree < cluster.in_degree) {
          acc[cluster.name] = cluster;
        }
        return acc;
      }, {});

      this.clusters = Object.values(groupedClusters);
      this.clusters.sort((a, b) => b.percentage - a.percentage);

      this.clusters.forEach((cluster, index) => {
        const color = index < topN ? this.colorPalette[index] : "#D3D3D3";
        cluster.color = color;
        if (!this.graphColorClusters.find((item) => item.name == cluster.name)) {
          this.graphColorClusters.push({ color, name: cluster.name });
        }
      });
    },
    getLabelById(nodeId) {
      const node = this.graphData.nodes.find((node) => node.id == String(nodeId));
      return node ? node.label : null;
    },
    getInDegreeById(nodeId) {
      const node = this.graphData.nodes.find((node) => node.id == String(nodeId));
      return node ? node.in_degree : null;
    },
    stopLayout() {
      this.isStartStop = false;

      this.layout.stop();

      const camera = this.renderer.getCamera();
      const currentZoom = camera.getState().ratio;

      const maxZoom = 0.2;
      camera.animate(
        {
          ratio: Math.max(currentZoom, maxZoom),
        },
        {
          duration: 2000,
          easing: 'linear',
        }
      );
    },
    resetLayout() {
      this.isStartStop = false;
      this.layout.stop();

      const camera = this.renderer.getCamera();
      camera.animate(
        { ratio: 1 },
        {
          duration: 1000,
          easing: 'linear',
        }
      );
    },
  },
};
</script>

<style scoped>
.color-box {
  width: 24px;
  height: 24px;
  border: 1px solid black;
}
.color-boxGeneratedColors {
  width: 185px;
  height: 28px;
  border: 1px solid black;
}
.color-row {
  display: flex;
  flex-wrap: nowrap;
  justify-content: start;
}
#sigma-container {
  width: 100%;
  height: 100%;
  min-width: 300px;
}
.btn-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
</style>